// src/utils/taskHandlers.ts
import { NavigateFunction } from "react-router-dom";
import config from "../../config";
import { TaskData } from "./taskTypes";
import logo from "../../Assets/j.png";
import ses from "../../Assets/ses.jpg";
import { useState } from "react";
import { authFetch } from "../Security/authFetch";
import { getSignatureLines } from "../emailSignature";
const email = localStorage.getItem("email");
const recipients = ["g.kattan@bcomsat.com"];

const isAdmin = localStorage.getItem("isAdmin") === "true";

const postMessage = async (payload: any) => {
  return authFetch(`${config.apiBaseUrl}/api/messages`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
};

const fetchEmailsWithRole2 = async (): Promise<string[]> => {
  try {
    const response = await authFetch(`${config.apiBaseUrl}/api/chm`);
    if (!response.ok) {
      throw new Error("Failed to fetch emails");
    }
    const data = await response.json();

    return data;
  } catch (err: any) {
    console.error("Email fetch failed:", err);
    return [];
  }
};
export const handleEdit = async (
  data: TaskData,
  navigate: NavigateFunction,
  fetchMessages: () => void
) => {
  const username = localStorage.getItem("username") || "System";

  const payload = {
    username,
    message: `Task With Id ${data.ticketId} Edited.`,
    date: new Date().toISOString(),
    read: false,
    ticketId: data.ticketId,
  };
  try {
    const emails = await fetchEmailsWithRole2();
    const isallsite = localStorage.getItem("isAllSite");
    const isallnetwork = localStorage.getItem("isAllNetwork");
    const isalllink = localStorage.getItem("isAllLink");
    const siteInfo =
      isallsite === "true" ? "All Sites" : data.affectedSite ?? "";
    const linkInfo =
      isalllink === "true" ? "All Links" : data.affectedLink ?? "";
    const networkInfo =
      isallnetwork === "true" ? "All Networks" : data.affectedNetwork ?? "";
    try {
      await authFetch(`${config.apiBaseUrl}/api/email/send`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },

        body: JSON.stringify({
          to: emails,
          subject: `Task ID ${data.ticketId} | ${data.affectedCustomer} | - Edited`,
          body: `
          <div style="font-family: Arial, sans-serif; font-size: 14px; color: #333; line-height: 1.6;">
            <p>Hello,</p>
            <p>A ticket with ID  ${
              data.ticketId
            } has been Edited with the following comment</p>
      <p><strong>Customer:</strong> ${data.affectedCustomer ?? ""}<br><br>
<strong>Network:</strong> ${data.affectedNetwork}<br><br>
              <strong>Site:</strong> ${data.affectedSite}<br><br>
              <strong>Link:</strong> ${data.affectedLink}<br><br>
<strong>Task Start Date:</strong> ${
            data.taskStartDatetime
              ? data.taskStartDatetime.replace("T", " ")
              : ""
          }<br><br>


<strong>Task Close Date:</strong> ${
            data.taskCloseDatetime
              ? data.taskCloseDatetime.replace("T", " ")
              : ""
          }<br><br><br>

      <strong>Summary:</strong> ${data.summary ?? ""}<br><br>
      <strong>Description:</strong> ${data.description ?? ""}<br><br>
      <strong>Closure Code:</strong> ${data.closureCode ?? ""}<br><br>
      <strong>Solution:</strong> ${data.solution ?? ""}</p>
            <p>
                         <p>Regards,<br><br><br><br></p>
              <a href=https://bdm.bcomsat.com target="_blank" style="color: #2a1364; font-weight: bold; text-decoration: none;">
                👉 View Task Details
              </a>
            </p>
            
            <table cellpadding="0" cellspacing="0" border="0" style="margin-top: 20px;">
      <tr>
        <td style="vertical-align: top; padding-right: 12px;">

         <img src="cid:seslogo" alt="SES Logo" style="height:50px;width:auto;" />
      

        </td>

        <td>
          <div style="
            padding: 12px;
            border-left: 4px solid #2a1364;
            background-color: #f9f9f9;
            color: #2a1364;
            font-size: 13px;
          ">
            <strong>Managed Services Operations</strong><br>
            ${getSignatureLines(data.affectedCustomer, "#2a1364")}
          </div>
        </td>
      </tr>
    </table>
          </div>
        `,
        }),
      });
    } catch (emailErr) {
      console.error("Failed to send fallback email notification:", emailErr);
    }

    const msgRes = await postMessage(payload);
    const updRes = await authFetch(
      `${config.apiBaseUrl}/api/tasks/${data.ticketId}`,
      { method: "PUT" }
    );

    if (msgRes.ok && updRes.ok) {
      fetchMessages();
    } else {
      console.error("Failed to accept or save message");
    }
  } catch (e) {
    console.error("Error while accepting task:", e);
  }
  try {
    const res = await postMessage(payload);
    if (res.ok) fetchMessages();
    else console.error("Failed to save message");
  } catch (e) {
    console.error("Error while saving message:", e);
  }

  navigate(`/task-edit/${data.ticketId}`, { state: { task: data } });
};

export const handleAccept = async (
  data: TaskData,
  fetchMessages: () => void
) => {
  const username = localStorage.getItem("username") || "System";
  const payload = {
    username,
    message: `Task With Id ${data.ticketId} Accepted.`,
    date: new Date().toISOString(),
    read: false,
    ticketId: data.ticketId,
  };

  try {
    const emails = await fetchEmailsWithRole2();
    const isallsite = localStorage.getItem("isAllSite");
    const isallnetwork = localStorage.getItem("isAllNetwork");
    const isalllink = localStorage.getItem("isAllLink");
    const siteInfo =
      isallsite === "true" ? "All Sites" : data.affectedSite ?? "";
    const linkInfo =
      isalllink === "true" ? "All Links" : data.affectedLink ?? "";
    const networkInfo =
      isallnetwork === "true" ? "All Networks" : data.affectedNetwork ?? "";
    try {
      await authFetch(`${config.apiBaseUrl}/api/email/send`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },

        body: JSON.stringify({
          to: emails,
          subject: `Task ID ${data.ticketId} | ${data.affectedCustomer} | - In Progress`,
          body: `
          <div style="font-family: Arial, sans-serif; font-size: 14px; color: #333; line-height: 1.6;">
            <p>Hello,</p>
            <p>A ticket with ID  ${
              data.ticketId
            } has been put in progress with the following comment</p>
      <p><strong>Customer:</strong> ${data.affectedCustomer ?? ""}<br><br>
<strong>Network:</strong> ${data.affectedNetwork}<br><br>
              <strong>Site:</strong> ${data.affectedSite}<br><br>
              <strong>Link:</strong> ${data.affectedLink}<br><br>
<strong>Task Start Date:</strong> ${
            data.taskStartDatetime
              ? data.taskStartDatetime.replace("T", " ")
              : ""
          }<br><br>


<strong>Task Close Date:</strong> ${
            data.taskCloseDatetime
              ? data.taskCloseDatetime.replace("T", " ")
              : ""
          }<br><br><br>

      <strong>Summary:</strong> ${data.summary ?? ""}<br><br>
      <strong>Description:</strong> ${data.description ?? ""}<br><br>
      <strong>Closure Code:</strong> ${data.closureCode ?? ""}<br><br>
      <strong>Solution:</strong> ${data.solution ?? ""}</p>
            <p>
                      <p>Regards,<br><br><br><br></p>
              <a href=https://bdm.bcomsat.com target="_blank" style="color: #2a1364; font-weight: bold; text-decoration: none;">
                👉 View Task Details
              </a>
            </p>
            
            <table cellpadding="0" cellspacing="0" border="0" style="margin-top: 20px;">
      <tr>
        <td style="vertical-align: top; padding-right: 12px;">

         <img src="cid:seslogo" alt="SES Logo" style="height:50px;width:auto;" />
      

        </td>

        <td>
          <div style="
            padding: 12px;
            border-left: 4px solid #2a1364;
            background-color: #f9f9f9;
            color: #2a1364;
            font-size: 13px;
          ">
            <strong>Managed Services Operations</strong><br>
            ${getSignatureLines(data.affectedCustomer, "#2a1364")}
          </div>
        </td>
      </tr>
    </table>
          </div>
        `,
        }),
      });
    } catch (emailErr) {
      console.error("Failed to send fallback email notification:", emailErr);
    }

    const msgRes = await postMessage(payload);
    const updRes = await authFetch(
      `${config.apiBaseUrl}/api/tasks/${data.ticketId}/accept`,
      { method: "PUT" }
    );

    if (msgRes.ok && updRes.ok) {
      fetchMessages();
      window.location.reload();
    } else {
      console.error("Failed to accept or save message");
    }
  } catch (e) {
    console.error("Error while accepting task:", e);
  }
};
export const handleClose = async (
  data: TaskData,
  fetchMessages: () => void
) => {
  const username = localStorage.getItem("username") || "System";


 const payload = {
    username,
    message:
      `Task With Id ${data.ticketId} Closed.\n` +
      `Closure Code: ${data.closureCode}\n` +
      `Solution: ${data.solution}`,

    date: new Date().toISOString(),
    read: false,
    ticketId: data.ticketId,
  };

  try {
    //console.log("Attempting to close task...");
    const updRes = await authFetch(
      `${config.apiBaseUrl}/api/tasks/${data.ticketId}/close`,
      {
        method: "PUT",
      }
    );

    if (updRes.ok) {
      //console.log("Task successfully closed.");
      fetchMessages();
    } else {
      console.error("Failed to close the task.");
      alert("Failed to close the task.");
    }
  } catch (err) {
    console.error("Error closing task:", err);
    alert("Error closing task: " + err);
    return;
  }

  try {
    //console.log("Attempting to post message...");
    const msgRes = await postMessage(payload);
    //console.log("Message sent:", msgRes);
  } catch (err) {
    console.error("Failed to post message:", err);
    alert("Failed to post message: " + err);
  }

  //console.log("Fetching emails with role 2...");
  try {
    const isallsite = localStorage.getItem("isAllSite");
    const isallnetwork = localStorage.getItem("isAllNetwork");
    const isalllink = localStorage.getItem("isAllLink");
    const siteInfo =
      isallsite === "true" ? "All Sites" : data.affectedSite ?? "";
    const linkInfo =
      isalllink === "true" ? "All Links" : data.affectedLink ?? "";
    const networkInfo =
      isallnetwork === "true" ? "All Networks" : data.affectedNetwork ?? "";
    const emails = await fetchEmailsWithRole2();
    //console.log("Emails fetched:", emails);
    const jackson = ["jacksondoumith006@gmail.com"];
    const emailBody = `
      <div style="font-family: Arial, sans-serif; font-size: 14px; color: #333; line-height: 1.6;">
        <p>Hello,</p>
        <p>This Ticket was Closed with the following comment:</p>
        <p>
          <strong>Customer:</strong> ${data.affectedCustomer ?? ""}<br><br>
<strong>Network:</strong> ${data.affectedNetwork}<br><br>
              <strong>Site:</strong> ${data.affectedSite}<br><br>
              <strong>Link:</strong> ${data.affectedLink}<br><br>
          <strong>Task Start Date:</strong> ${
            data.taskStartDatetime?.replace("T", " ") ?? ""
          }<br><br>
          <strong>Task Close Date:</strong> ${
            data.taskCloseDatetime?.replace("T", " ") ?? ""
          }<br><br>
          <strong>Summary:</strong> ${data.summary ?? ""}<br><br>
          <strong>Description:</strong> ${data.description ?? ""}<br><br>
          <strong>Closure Code:</strong> ${data.closureCode ?? ""}<br><br>
          <strong>Solution:</strong> ${data.solution ?? ""}<br><br>
        </p>
        <p>
                 <p>Regards,<br><br><br><br></p>
              <a href=https://bdm.bcomsat.com target="_blank" style="color: #2a1364; font-weight: bold; text-decoration: none;">
                👉 View Task Details
              </a>
            </p>
            
            <table cellpadding="0" cellspacing="0" border="0" style="margin-top: 20px;">
      <tr>
        <td style="vertical-align: top; padding-right: 12px;">

         <img src="cid:seslogo" alt="SES Logo" style="height:50px;width:auto;" />
      

        </td>

        <td>
          <div style="
            padding: 12px;
            border-left: 4px solid #2a1364;
            background-color: #f9f9f9;
            color: #2a1364;
            font-size: 13px;
          ">
            <strong>Managed Services Operations</strong><br>
            ${getSignatureLines(data.affectedCustomer, "#2a1364")}
          </div>
        </td>
      </tr>
    </table>
      </div>
    `;

    //console.log("Sending email...");
    await authFetch(`${config.apiBaseUrl}/api/email/send`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        to: emails,
        subject: `Task ID ${data.ticketId} | ${data.affectedCustomer} | - Closed`,
        body: emailBody,
      }),
    });
    //console.log("Email sent successfully.");

    // Reload the page after success
    window.location.reload();
  } catch (e) {
    console.error("Error sending email:", e);
    alert("Error sending email: " + e);
  }
};

export const handlePause = async (
  data: TaskData,
  fetchMessages: () => void
) => {
  const comment = localStorage.getItem("taskcomment") || "System";
  const username = localStorage.getItem("username") || "System";
  const isallsite = localStorage.getItem("isAllSite");
  const isallnetwork = localStorage.getItem("isAllNetwork");
  const isalllink = localStorage.getItem("isAllLink");
  const siteInfo = isallsite === "true" ? "All Sites" : data.affectedSite ?? "";
  const linkInfo = isalllink === "true" ? "All Links" : data.affectedLink ?? "";
  const networkInfo =
    isallnetwork === "true" ? "All Networks" : data.affectedNetwork ?? "";
  const payload = {
    username,
    message: `Task With Id ${data.ticketId} Paused.`,
    date: new Date().toISOString(),
    read: false,
    ticketId: data.ticketId,
  };

  try {
    // 1. Send internal message
    const msgRes = await postMessage(payload);

    // 2. Update task status to "paused"
    const updRes = await authFetch(
      `${config.apiBaseUrl}/api/tasks/${data.ticketId}/pause`,
      { method: "PUT" }
    );

    // 3. Fetch emails with role
    const emails = await fetchEmailsWithRole2();

    // 4. Send notification email
    await authFetch(`${config.apiBaseUrl}/api/email/send`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        to: emails,
        subject: `Task ID ${data.ticketId} | ${data.affectedCustomer} | - On Hold`,
        body: `
          <div style="font-family: Arial, sans-serif; font-size: 14px; color: #333; line-height: 1.6;">
            <p>Hello,</p>
            <p>A ticket with ID ${
              data.ticketId
            } has been put on hold with the following comment</p>
            <p><strong>Customer:</strong> ${data.affectedCustomer ?? ""}<br><br>
<strong>Network:</strong> ${data.affectedNetwork}<br><br>
              <strong>Site:</strong> ${data.affectedSite}<br><br>
              <strong>Link:</strong> ${data.affectedLink}<br><br>
            <strong>Task Start Date:</strong> ${
              data.taskStartDatetime
                ? data.taskStartDatetime.replace("T", " ")
                : ""
            }<br><br>
            <strong>Task Close Date:</strong> ${
              data.taskCloseDatetime
                ? data.taskCloseDatetime.replace("T", " ")
                : ""
            }<br><br>
            <strong>Summary:</strong> ${data.summary ?? ""}<br><br>
            <strong>Description:</strong> ${data.description ?? ""}<br><br>
            <strong>Closure Code:</strong> ${data.closureCode ?? ""}<br><br>
            <strong>Solution:</strong> ${data.solution ?? ""}</p>
             <strong>Comment:</strong> ${comment ?? ""}</p>
            <p>
                        <p>Regards,<br><br><br><br></p>
              <a href=https://bdm.bcomsat.com target="_blank" style="color: #2a1364; font-weight: bold; text-decoration: none;">
                👉 View Task Details
              </a>
            </p>
            
            <table cellpadding="0" cellspacing="0" border="0" style="margin-top: 20px;">
      <tr>
        <td style="vertical-align: top; padding-right: 12px;">

         <img src="cid:seslogo" alt="SES Logo" style="height:50px;width:auto;" />
      

        </td>

        <td>
          <div style="
            padding: 12px;
            border-left: 4px solid #2a1364;
            background-color: #f9f9f9;
            color: #2a1364;
            font-size: 13px;
          ">
            <strong>Managed Services Operations</strong><br>
            ${getSignatureLines(data.affectedCustomer, "#2a1364")}
          </div>
        </td>
      </tr>
    </table>
          </div>
        `,
      }),
    });

    if (msgRes.ok && updRes.ok) {
      fetchMessages();
      window.location.reload();
    } else {
      console.error("Failed to pause task or save message");
    }
  } catch (error) {
    console.error("Error while pausing task:", error);
  }
};

export const handleReactivate = async (
  data: TaskData,
  fetchMessages: () => void
) => {
  const username = localStorage.getItem("username") || "System";
  const payload = {
    username,
    message: `Task With Id ${data.ticketId} Reactivated.`,
    date: new Date().toISOString(),
    read: false,
    ticketId: data.ticketId,
  };

  try {
    // 1. Save message
    const msgRes = await postMessage(payload);

    // 2. Update task status
    const updRes = await authFetch(
      `${config.apiBaseUrl}/api/tasks/${data.ticketId}/reactivate`,
      { method: "PUT" }
    );
    const isallsite = localStorage.getItem("isAllSite");
    const isallnetwork = localStorage.getItem("isAllNetwork");
    const isalllink = localStorage.getItem("isAllLink");
    const siteInfo =
      isallsite === "true" ? "All Sites" : data.affectedSite ?? "";
    const linkInfo =
      isalllink === "true" ? "All Links" : data.affectedLink ?? "";
    const networkInfo =
      isallnetwork === "true" ? "All Networks" : data.affectedNetwork ?? "";
    // 3. Fetch emails
    const emails = await fetchEmailsWithRole2();
    // 4. Send notification email
    await authFetch(`${config.apiBaseUrl}/api/email/send`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        to: emails,
        subject: `Task ID ${data.ticketId} | ${data.affectedCustomer} | - Reactivated`,
        body: `
          <div style="font-family: Arial, sans-serif; font-size: 14px; color: #333; line-height: 1.6;">
            <p>Hello,</p>
            <p>A ticket with ID ${
              data.ticketId
            } has been reactivated with the following comment:</p>
            <p>
              <strong>Customer:</strong> ${data.affectedCustomer ?? ""}<br><br>
<strong>Network:</strong> ${data.affectedNetwork}<br><br>
              <strong>Site:</strong> ${data.affectedSite}<br><br>
              <strong>Link:</strong> ${data.affectedLink}<br><br>
              <strong>Task Start Date:</strong> ${
                data.taskStartDatetime
                  ? data.taskStartDatetime.replace("T", " ")
                  : ""
              }<br><br>
              <strong>Task Close Date:</strong> ${
                data.taskCloseDatetime
                  ? data.taskCloseDatetime.replace("T", " ")
                  : ""
              }<br><br>
              <strong>Summary:</strong> ${data.summary ?? ""}<br><br>
              <strong>Description:</strong> ${data.description ?? ""}<br><br>
              <strong>Closure Code:</strong> ${data.closureCode ?? ""}<br><br>
              <strong>Solution:</strong> ${data.solution ?? ""}
            </p>
            <p>
                        <p>Regards,<br><br><br><br></p>
              <a href=https://bdm.bcomsat.com target="_blank" style="color: #2a1364; font-weight: bold; text-decoration: none;">
                👉 View Task Details
              </a>
            </p>
            
            <table cellpadding="0" cellspacing="0" border="0" style="margin-top: 20px;">
      <tr>
        <td style="vertical-align: top; padding-right: 12px;">

         <img src="cid:seslogo" alt="SES Logo" style="height:50px;width:auto;" />
      

        </td>

        <td>
          <div style="
            padding: 12px;
            border-left: 4px solid #2a1364;
            background-color: #f9f9f9;
            color: #2a1364;
            font-size: 13px;
          ">
            <strong>Managed Services Operations</strong><br>
            ${getSignatureLines(data.affectedCustomer, "#2a1364")}
          </div>
        </td>
      </tr>
    </table>
          </div>
        `,
      }),
    });

    // 5. Finalize
    if (msgRes.ok && updRes.ok) {
      fetchMessages();
      window.location.reload();
    } else {
      console.error("Failed to reactivate or save message");
    }
  } catch (e) {
    console.error("Error while reactivating task:", e);
  }
};

export const handleReopen = async (
  data: TaskData,
  fetchMessages: () => void
) => {
  const username = localStorage.getItem("username") || "System";
  const payload = {
    username,
    message: `Task With Id ${data.ticketId} Reopened.`,
    date: new Date().toISOString(),
    read: false,
    ticketId: data.ticketId,
  };

  try {
    const msgRes = await postMessage(payload);
    const updRes = await authFetch(
      `${config.apiBaseUrl}/api/tasks/${data.ticketId}/reopen`,
      { method: "PUT" }
    );

    if (msgRes.ok && updRes.ok) {
      fetchMessages();
      window.location.reload();
    } else {
      console.error("Failed to Reactivate or save message");
    }
  } catch (e) {
    console.error("Error while Reactivating task:", e);
  }

  try {
    const isallsite = localStorage.getItem("isAllSite");
    const isallnetwork = localStorage.getItem("isAllNetwork");
    const isalllink = localStorage.getItem("isAllLink");
    const siteInfo =
      isallsite === "true" ? "All Sites" : data.affectedSite ?? "";
    const linkInfo =
      isalllink === "true" ? "All Links" : data.affectedLink ?? "";
    const networkInfo =
      isallnetwork === "true" ? "All Networks" : data.affectedNetwork ?? "";
    const emails = await fetchEmailsWithRole2();
    await authFetch(`${config.apiBaseUrl}/api/email/send`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        to: emails,
        subject: `Task ID ${data.ticketId} | ${data.affectedCustomer} | - Reopened`,
        body: `
          <div style="font-family: Arial, sans-serif; font-size: 14px; color: #333; line-height: 1.6;">
            <p>Hello,</p>
           <p>This Ticket was Reopened with following comment:</p>
                 <p><strong>Customer:</strong> ${
                   data.affectedCustomer ?? ""
                 }<br><br>
 <strong>Network:</strong> ${data.affectedNetwork}<br><br>
              <strong>Site:</strong> ${data.affectedSite}<br><br>
              <strong>Link:</strong> ${data.affectedLink}<br><br>
<strong>Task Start Date:</strong> ${
          data.taskStartDatetime ? data.taskStartDatetime.replace("T", " ") : ""
        }<br><br>


<strong>Task Close Date:</strong> ${
          data.taskCloseDatetime ? data.taskCloseDatetime.replace("T", " ") : ""
        }<br><br>

      <strong>Summary:</strong> ${data.summary ?? ""}<br><br>
      <strong>Description:</strong> ${data.description ?? ""}<br><br>
      <strong>Closure Code:</strong> ${data.closureCode ?? ""}<br><br>
      <strong>Solution:</strong> ${data.solution ?? ""}</p>
            <p>
                        <p>Regards,<br><br><br><br></p>
              <a href=https://bdm.bcomsat.com target="_blank" style="color: #2a1364; font-weight: bold; text-decoration: none;">
                👉 View Task Details
              </a>
            </p>
            
            <table cellpadding="0" cellspacing="0" border="0" style="margin-top: 20px;">
      <tr>
        <td style="vertical-align: top; padding-right: 12px;">

         <img src="cid:seslogo" alt="SES Logo" style="height:50px;width:auto;" />
      

        </td>

        <td>
          <div style="
            padding: 12px;
            border-left: 4px solid #2a1364;
            background-color: #f9f9f9;
            color: #2a1364;
            font-size: 13px;
          ">
            <strong>Managed Services Operations</strong><br>
            ${getSignatureLines(data.affectedCustomer, "#2a1364")}
          </div>
        </td>
      </tr>
    </table>
          </div>
        `,
      }),
    });
    //console.log("Email sent: Customer was NOT informed.");
  } catch (emailErr) {
    console.error("Failed to send fallback email notification:", emailErr);
  }
};
